import { Component } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.html',
  styleUrl: './about-us.scss'
})
export class AboutUs {

}
